module.exports = __webpack_public_path__ + "static/img/wood101.8e753d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood101.jpg
// module id = C8YE
// module chunks = 0